import { Injectable } from '@angular/core';
import { BaseWalkthroughStepComponent } from 'src/app/components/walkthroughs/base-walkthrough-step/base-walkthrough-step.component';
import { MainWalkthroughIntroComponent } from 'src/app/components/walkthroughs/main-walkthrough-intro/main-walkthrough-intro.component';
import { StorageService } from '../../utils/storage/storage.service';
import { HubIndicatorWalkthroughComponent } from 'src/app/components/walkthroughs/hub-indicator-walkthrough/hub-indicator-walkthrough.component';
import { DefaultSeriesIntroWalkthroughComponent } from 'src/app/components/walkthroughs/default-series-intro-walkthrough/default-series-intro-walkthrough.component';
import { SearchWalkthroughComponent } from 'src/app/components/walkthroughs/search-walkthrough/search-walkthrough.component';
import { ItemSummaryWalkthroughComponent } from 'src/app/components/walkthroughs/item-summary-walkthrough/item-summary-walkthrough.component';

import size from 'lodash/size';
import filter from 'lodash/filter';

export interface IWalkthrough {
  component: BaseWalkthroughStepComponent | any;
  series: number;
  classList: string;
  skipOnFirstWalkthrough?: boolean;
  params?: {
    [key: string]: any;
  };
}

@Injectable({
  providedIn: 'root',
})
export class WalkthroughService {
  /**
   * The list of walkthroughs to display
   */
  private _walkthroughs: IWalkthrough[] = [
    {
      component: MainWalkthroughIntroComponent,
      classList: 'main-walkthrough-intro',
      series: 1,
    },
    {
      component: HubIndicatorWalkthroughComponent,
      classList: 'hub-indicator-walkthrough',
      series: 1,
    },
    {
      component: SearchWalkthroughComponent,
      classList: 'search-walkthrough-intro',
      series: 1,
    },
    {
      component: ItemSummaryWalkthroughComponent,
      classList: 'item-summary-walkthrough',
      series: 1,
    },
    // {
    //   component: DefaultSeriesIntroWalkthroughComponent,
    //   classList: "default-walkthrough-intro",
    //   series: 2
    // },
    // {
    //   component: WalkthroughStep3Component,
    //   classList: "walkthrough-step-3",
    //   series: 1
    // },
    // {
    //   component: WalkthroughStep1Component,
    //   classList: "walkthrough-step-4",
    //   series: 2,
    //   params: {
    //     title: "Second Page"
    //   }
    // },
    // {
    //   component: WalkthroughStep2Component,
    //   classList: "walkthrough-step-5",
    //   series: 3,
    //   skipOnFirstWalkthrough: true,
    //   params: {
    //     title: "INTRO Page"
    //   }
    // },
    // {
    //   component: WalkthroughStep2Component,
    //   classList: "walkthrough-step-5",
    //   series: 3,
    //   params: {
    //     title: "Second Page"
    //   }
    // },
  ];

  constructor(public storage: StorageService) {}

  /**
   * Returns the last series of walkthrough viewed
   */
  async getLastIndex() {
    const version = await this.storage.load('walkthrough');
    return version || 0;
  }

  /**
   * Save and update the last series of walkthrough viewed
   */
  async saveLastIndex() {
    await this.storage.save('walkthrough', this.getMaxSeries());
  }

  /**
   * Returns the max available walkthrough series
   */
  public getMaxSeries(): number {
    let series: number = 0;
    for (let walkthrough of this._walkthroughs) {
      series = Math.max(series, walkthrough.series);
    }

    return series;
  }

  /**
   * Returns a list of walkthroughs by passing the series
   * @param series - The starting series
   */
  public getWalkthroughStartingFrom(series: number): IWalkthrough[] {
    return filter(this._walkthroughs, (walkthrough: IWalkthrough) => walkthrough.series >= series);
  }

  async needWalkthrough() {
    const wtIndex = await this.getLastIndex();
    const series: number = this.getMaxSeries();
    const walkthroughs: number = size(this._walkthroughs);

    return walkthroughs > 0 && wtIndex < series;
  }

  public get Walkthroughs(): IWalkthrough[] {
    return this._walkthroughs;
  }
}
